import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useSubscription } from '@/context/SubscriptionContext';

export const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { checkSubscription } = useSubscription();

  useEffect(() => {
    // Rafraîchir le statut d'abonnement après le paiement réussi
    checkSubscription();
  }, [checkSubscription]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-emerald-50 p-4">
      <Card className="w-full max-w-md border-green-200">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <CardTitle className="text-2xl text-green-800">
            Paiement réussi !
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 text-center">
          <div className="space-y-2">
            <p className="text-green-700 font-medium">
              Votre abonnement a été activé avec succès
            </p>
            <p className="text-sm text-muted-foreground">
              Vous avez maintenant accès à toutes les fonctionnalités premium de l'application
            </p>
          </div>
          
          <div className="bg-green-50 p-4 rounded-lg border border-green-200">
            <h3 className="font-medium text-green-800 mb-2">Prochaines étapes :</h3>
            <ul className="text-sm text-green-700 space-y-1 text-left">
              <li>• Accédez au dashboard complet</li>
              <li>• Gérez votre stock en temps réel</li>
              <li>• Invitez votre équipe</li>
              <li>• Consultez vos rapports détaillés</li>
            </ul>
          </div>

          <Button 
            onClick={() => navigate('/dashboard')}
            className="w-full bg-green-600 hover:bg-green-700"
            size="lg"
          >
            Accéder au dashboard
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};